(function($) {
	$(document).ready(function() {
		// no rules required, leave everything to html5 markup rules
		$('#mailchimp-signup-form').validate();
	});
}(jQuery));
